import { HttpClient, HttpContextToken, HttpHandler } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigurableHttpClient } from '@corelabs/angular/core';
import { SKIP_ERROR_MESSAGE } from '../http-context';

// HttpClient is declared in a re-exported module, so we augment the original module to make it work
// properly (see https://github.com/Microsoft/TypeScript/issues/13897). This exposes the fluent
// builder methods on the HttpClient *type*, so call sites that `inject(HttpClient)` see them with no
// casting once HttpClient is DI-swapped for HttpService.
declare module '@angular/common/http' {
    export interface HttpClient {
        /** Skips the error-message toast for this request. */
        skipErrorMessageInterceptor(): HttpClient;
    }
}

// Undecorated, so it is free to take (handler, tokens) for clone() to rebuild. An @Injectable()
// carrying that constructor fails AOT with NG2003 — ReadonlySet has no injection token.
class AppHttpClient extends ConfigurableHttpClient {
    override skipErrorMessageInterceptor(): HttpClient {
        return this.with(SKIP_ERROR_MESSAGE);
    }

    protected override clone(tokens: ReadonlySet<HttpContextToken<boolean>>): AppHttpClient {
        return new AppHttpClient(this.httpHandler, tokens);
    }
}

/**
 * The DI entry point — arg-less, exactly like the library's own HttpService. Registered via the
 * explicit `{ provide: HttpClient, useClass: HttpService }` swap in `app.config.ts`, placed after
 * `provideCore()` so it wins the HttpClient token.
 */
@Injectable()
export class HttpService extends AppHttpClient {
    constructor() {
        super(inject(HttpHandler), new Set());
    }
}
